/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_SubtitleInputs */

const zh_landing_audience_subtitle = /** @type {(inputs: Landing_Audience_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS 为教育者带来灵活、高效与简洁。`)
};

const en_landing_audience_subtitle = /** @type {(inputs: Landing_Audience_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS offers educators flexibility, speed, and simplicity.`)
};

const es_landing_audience_subtitle = /** @type {(inputs: Landing_Audience_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS ofrece a los educadores flexibilidad, velocidad y simplicidad.`)
};

/**
* | output |
* | --- |
* | "StudyOS offers educators flexibility, speed, and simplicity." |
*
* @param {Landing_Audience_SubtitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_subtitle = /** @type {((inputs?: Landing_Audience_SubtitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_SubtitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_subtitle(inputs)
	if (locale === "en") return en_landing_audience_subtitle(inputs)
	return es_landing_audience_subtitle(inputs)
});